import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

interface IBlockStatus {
    blocked: boolean;
    label?: string;
    invokerId?: string;
}

@Injectable()
export class NgWaitService {
    private static instance: NgWaitService = null;

    private blockUpdated$: Subject<IBlockStatus> = new Subject();

    public static getInstance() {
        if (!NgWaitService.instance) {
            NgWaitService.instance = new NgWaitService();
        }
        return NgWaitService.instance;
    }

    public getBlockSubject() {
        return this.blockUpdated$;
    }

    public block(label = "Loading", invokerId?: string): void {
        this.blockUpdated$.next({ blocked: true, label, invokerId });
    }

    public unblock(invokerId?: string): void {
        this.blockUpdated$.next({ blocked: false, invokerId });
    }
}
